// Generated by scripts/generate-icons.ts
/* eslint-disable */

// This file is auto-generated. Do not edit manually.
import React from 'react';
import { BaseIcon } from '../src/components/BaseIcon';
import type { IconDefinition, IconPath } from '../src/types/IconData.types';

const iconData: IconDefinition = {
  name: "ArrowLeft",
  viewBox: "0 0 20 20",
  paths: [
    {
      d: "M18 10.048c0 .116-.05.227-.142.309a.5.5 0 0 1-.342.128H3.704l5.275 4.767q.068.061.105.142a.4.4 0 0 1 0 .335.4.4 0 0 1-.105.143.528.528 0 0 1-.686 0L2.14 10.31A.42.42 0 0 1 2 10c0-.116.05-.227.139-.31h-.07l6.154-5.562A.5.5 0 0 1 8.566 4c.129 0 .252.046.343.128.09.083.142.194.142.31a.42.42 0 0 1-.142.31l-5.39 4.87h13.997a.52.52 0 0 1 .342.123q.068.061.105.14a.4.4 0 0 1 .037.167",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  ]
};

export const ArrowLeftIcon: React.FC<React.SVGProps<SVGSVGElement> & { iconPathClassName?: string }> = (props) => {
  return <BaseIcon icon={iconData} {...props} />;
};
